export default __webpack_public_path__ + "static/media/MH-Gen-AI-Dark.d5336c6f.png";